<template>
  <div class="content-404 flex">
    <div class="flex">
      <img class="flex img-404" src="/static/404.png" alt="404" />
    </div>
    <div class="flex algin-center flex-direction">
      <h2>错误</h2>
      <p>页面未找到</p>
      <p>这可能是URL或已删除页面中的拼写错误</p>
      <el-button class="btn-404" type="primary" @click="doNav"
        >返回首页</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'notFound',
  methods: {
    doNav() {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('../../styles/main.scss');
.content-404 {
  position: relative;
  justify-content: center;
  align-items: center;
  height: 600px;
}
.btn-404 {
  position: relative;
  margin-top: 20px;
  border-radius: 5000px;
}
.img-404 {
  width: 100%;
  position: relative;
}
h2 {
  font-size: 36px;
  line-height: 50px;
  color: #1691f6;
  margin-bottom: 10px;
}
p {
  font-size: 16px;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/views/error-page/notFound.vue